<template>
    <div class="container">
      <el-container style="min-height: 100vh; border: 0 solid #eee">
        <!-- 边框 -->
        <el-aside :width="sideWidth + 'px'" style="background-color: rgb(238, 241, 246);" >
          <Aside :isCollapse="isCollapse" :logoTextShow="logoTextShow" :sideWidth="sideWidth"/>
        </el-aside>
        <el-container>
          <!-- 头标 -->
          <el-header style="font-size: 12px; border-bottom: 1px solid #ccc;">
            <Header :CollapseBtnClass = "CollapseBtnClass" :collapse = "collapse"></Header>
          </el-header>
          <!-- 主体 -->
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  

 const Aside = () => import('./components/Aside');
 const Header = () => import('./components/Header');
//   import Aside from "./backstage/components/Aside";
//   import Header from "./backstage/components/Header";
  
  export default {
    components: {Header, Aside},
    data () {
      return {
        CollapseBtnClass: 'el-icon-s-fold',
        isCollapse: false,
        sideWidth: 200,
        logoTextShow:true
      }
    },
    methods: {
      collapse() { // 点击触发按钮时触发此函数
        this.isCollapse = !this.isCollapse
        if (this.isCollapse) { // 展开
          this.sideWidth = 65
          this.CollapseBtnClass = 'el-icon-s-unfold'
          this.logoTextShow = false
        } else { // 收缩
          this.sideWidth = 200
          this.CollapseBtnClass = 'el-icon-s-fold'
          this.logoTextShow = true
        }
      },
    },
    mounted() {
    },
  }
  </script>
  <style>
  .headerBg{
    background: #cdc9c9!important;
  }
  </style>
  